import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginShell from './LoginShell';
import { clearStayOnLanding } from '../../config/sessionKeys';

function slugify(s) {
    return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}

// Step 1 of the WT-style login: the user enters their workspace slug, which routes
// them to the branded /login/:slug sign-in screen.
export default function WorkspaceLogin() {
    const navigate = useNavigate();
    const [slug, setSlug] = useState('');

    const go = (e) => {
        e.preventDefault();
        const s = slugify(slug);
        if (!s) return;
        clearStayOnLanding();
        navigate(`/login/${s}`);
    };

    return (
        <LoginShell>
            <span className="lg-eyebrow">Sign in</span>
            <h1 className="lg-title">Enter your workspace</h1>
            <p className="lg-sub">Your dealership’s workspace address — the same one from your welcome email.</p>
            <form onSubmit={go}>
                <div className="lg-slug-row">
                    <span className="lg-slug-prefix">ironsight /</span>
                    <input
                        autoFocus
                        placeholder="your-dealership"
                        value={slug}
                        onChange={(e) => setSlug(e.target.value)}
                        aria-label="Workspace address"
                    />
                </div>
                <button className="lg-btn" type="submit" disabled={!slugify(slug)}>
                    Continue <span aria-hidden="true">→</span>
                </button>
            </form>
            <button className="lg-link" onClick={() => navigate('/login/fusable')}>Staff sign-in</button>
        </LoginShell>
    );
}
